import usePreviousPath from "@casino/legacy/client/hooks/router/usePreviousPath";
import DarkThemeProvider from "@casino/legacy/client/shared/ThemeProviders/DarkThemeProvider";

type Props = { hasBombayClubTheme?: boolean };

const BrandThemeProvider: FC<Props> = ({ children, hasBombayClubTheme }) => {
  const { isBombayClubTheme } = useIsBombayClubTheme();
  if (isBombayClubTheme && hasBombayClubTheme) {
    return <DarkThemeProvider>{children}</DarkThemeProvider>;
  }
  return <>{children}</>;
};

const useIsBombayClubTheme = () => {
  const { getPreviousPath } = usePreviousPath();
  const path = getPreviousPath();
  const isBombayClubTheme = path?.includes("/bombayclub");
  return { isBombayClubTheme };
};

export default BrandThemeProvider;
